import { GRID_SIZE } from '../config/constants'

const playerPosKey = (dungeonKey) => `dungeon_player_pos_${dungeonKey}`
const PENDING_COLLECTIONS_KEY = 'pinmonkey_pending_collections'

export const snapToGrid = (x, y, gridSize = GRID_SIZE) => ({
  x: Math.floor(x / gridSize) * gridSize,
  y: Math.floor(y / gridSize) * gridSize,
})

export const loadPlayerPos = (dungeonKey) => {
  try {
    const stored = localStorage.getItem(playerPosKey(dungeonKey))
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

export const savePlayerPos = (dungeonKey, x, y, gridSize = GRID_SIZE) => {
  localStorage.setItem(playerPosKey(dungeonKey), JSON.stringify(snapToGrid(x, y, gridSize)))
}

export const clearPlayerPos = (dungeonKey) => {
  localStorage.removeItem(playerPosKey(dungeonKey))
}

export const loadPendingCollections = () => {
  try {
    return JSON.parse(localStorage.getItem(PENDING_COLLECTIONS_KEY) || '[]')
  } catch {
    return []
  }
}

export const addPendingCollection = (entry) => {
  const pending = loadPendingCollections()
  if (!pending.some((p) => p.treasureId === entry.treasureId && p.dungeonSlug === entry.dungeonSlug)) {
    localStorage.setItem(PENDING_COLLECTIONS_KEY, JSON.stringify([...pending, entry]))
  }
}

export const removePendingCollection = (treasureId, dungeonSlug) => {
  const pending = loadPendingCollections().filter(
    (p) => !(p.treasureId === treasureId && p.dungeonSlug === dungeonSlug)
  )
  localStorage.setItem(PENDING_COLLECTIONS_KEY, JSON.stringify(pending))
}
